import React from "react";
import { get } from "lodash-es";
import { selectServiceModule } from "features/metadesk/redux/entityConfig/entityConfig.selector";
import { useSelector } from "react-redux";
import useNavigateEntity from "hooks/useNavigateEntity";
import PlatformAnalysisContent from "./PlatformAnalysisContent";
import EmptyImgStatus from "components/EmptyState/EmptyImageStatus";
import DateArea from "./DateArea";
import { useIntl } from "react-intl";
import CommunityAnalysisContext from "features/metadesk/CommunityAnalysis/contexts/CommunityAnalysis.context";
import { useParams } from "react-router";

const TelegramContainer = () => {
  const { navigateEntity } = useNavigateEntity();
  const serviceModule = useSelector(selectServiceModule);
  const { subEntityName } = useParams();
  const isTelegramConnected =
    subEntityName || get(serviceModule, "telegramAnalytics.connected");
  const { formatMessage } = useIntl();

  if (!isTelegramConnected) {
    return (
      <div className="fade-up-more">
        <DateArea
          sx={{ marginBottom: "8px" }}
          context={CommunityAnalysisContext}
        />
        <EmptyImgStatus
          type="integrate"
          backgroundImg={"Community"}
          description={formatMessage({
            id: "emptyStatus.notIntegrated.description.telegramBot",
          })}
          onClick={() =>
            navigateEntity("/settings/customization/telegramAnalyticsSetting")
          }
        />
      </div>
    );
  }
  return (
    <PlatformAnalysisContent
      type="telegram"
      isConnected={isTelegramConnected}
    />
  );
};

export default TelegramContainer;
